export function gerarUrl(params) {
  const queryParams = params
    ? Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&")
    : "";
  return queryParams;
}
